import { Button, Link } from 'components'
import React from 'react'

import { ArrowRightIcon } from '@radix-ui/react-icons'

import { useGenerateApplyNowLink } from '../../components/useGenerateApplyNowLink'
import { bootcampsData, BootcampsType } from '../../data/bootcampsData'

const HeroSection = (prop: { type?: BootcampsType }) => {
  const { type = 'fullstack' } = prop
  const to = useGenerateApplyNowLink(type)

  return (
    <div className="bg-gradient-to-b from-[#3c3c78] to-[#3c3c7800] min-h-screen">
      <div className="flex flex-col gap-12 sm:gap-16 py-20 px-4 max-w-7xl mx-auto items-center">
        <h1 className="text-5xl sm:text-7xl font-bold text-center">
          {bootcampsData[type].heading}
        </h1>
        <div className="text-2xl sm:text-3xl text-center sm:w-3/5">
          <p className="">
            {bootcampsData[type].subheading}
            <span className="text-[#FFB300] font-semibold px-2">
              {bootcampsData[type].highlightedSubheading}
            </span>
          </p>
        </div>

        <div className="flex justify-center items-center w-full">
          <Link href={to}>
            <Button className="bg-primary rounded-none">
              Apply Now
              <span>
                <ArrowRightIcon className="w-6 h-6 font-bold mx-2" />
              </span>
            </Button>
          </Link>
        </div>

        <div className="flex justify-center items-center rounded-md w-full">
          <div
            className="rounded-3xl w-full sm:w-1/2"
            style={{
              boxShadow: '0px 0px 32px 1px #8080FF40'
            }}>
            <div className="flex flex-row justify-between sm:items-center px-12 sm:px-24 py-10">
              <div className="flex flex-col sm:justify-end sm:items-end">
                <div>Batch Starting</div>
                <div className="text-[#FFB300] font-semibold text-xl">
                  {bootcampsData[type].starting}
                </div>
              </div>
              <div className="hidden sm:block border-r-2 border-gray-500 w-2 h-10"></div>
              <div className="flex flex-col sm:justify-end sm:items-start">
                <div>Duration</div>
                <div className="text-[#FFB300] font-semibold text-xl">
                  {bootcampsData[type].duration}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection
